export default "__VITE_ASSET__gSCIA9du__"